import {useSelector} from 'react-redux';

export default () =>
	useSelector(({timezones}) => {
		const isTimeZonesLoaded = timezones?.length > 0;
		return {isTimeZonesLoaded, timezones};
	});
